/**
 * Walk up from a node to the nearest scrollable ancestor — the element a long page list actually scrolls
 * within (the admin shell's `<main>`), so a virtualizer windows against the page scroller, not a bounded
 * internal region. Falls back to the document scrolling element when none is found.
 */
export function findScrollParent(node: HTMLElement | null): HTMLElement | null {
  let el: HTMLElement | null = node?.parentElement ?? null;
  while (el) {
    const style =
      typeof window !== 'undefined' && typeof window.getComputedStyle === 'function'
        ? window.getComputedStyle(el)
        : null;
    const overflowY = style?.overflowY;
    if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') {
      return el;
    }
    el = el.parentElement;
  }
  return typeof document !== 'undefined'
    ? ((document.scrollingElement as HTMLElement | null) ?? document.documentElement)
    : null;
}

/**
 * Where a list starts inside its scroller, in the scroller's content coordinates — a virtualizer's
 * `scrollMargin`. The document scroller's own box moves as it scrolls, so it counts from the viewport top.
 */
export function offsetWithin(node: HTMLElement, scroller: HTMLElement): number {
  const isDocument = scroller === document.scrollingElement || scroller === document.documentElement;
  const scrollerTop = isDocument ? 0 : scroller.getBoundingClientRect().top;
  return node.getBoundingClientRect().top - scrollerTop + scroller.scrollTop;
}
